import { Button, Form, Select, Switch, Input } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { forwardRef, useImperativeHandle, useMemo } from 'react';

const RadiologistUserForm = forwardRef(function RadiologistUserForm(
  { formValues, onSubmit, loading, isEdit = false },
  ref
) {
  // Remove +1 prefix from mobile number if it exists in formValues
  const processedFormValues = useMemo(() => {
    if (!formValues || !formValues.mobile) {
      return formValues;
    }
    let mobile = formValues.mobile;
    // Remove +1 or 1 prefix if present
    if (typeof mobile === 'string') {
      mobile = mobile.replace(/^\+?1/, '').trim();
    }
    return {
      ...formValues,
      mobile: mobile,
    };
  }, [formValues]);

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    reset,
  } = useForm({
    values: processedFormValues,
  });

  // Wrapper to add +1 prefix to mobile before submitting
  const handleFormSubmit = (data) => {
    const submitData = {
      ...data,
      mobile: data.mobile ? `+1${data.mobile.replace(/^\+?1/, '')}` : data.mobile,
    };
    onSubmit(submitData);
  };

  useImperativeHandle(
    ref,
    () => ({
      reset: reset,
    }),
    [reset]
  );

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <div className="form-group">
        <label
          style={{
            zIndex: 10000,
          }}
        >
          Title <span className="login-danger">*</span>
        </label>
        <Controller
          name="nameTitle"
          control={control}
          disabled={isEdit}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              {...field}
              className="form-control menu-classM"
              options={[
                {
                  value: 'Mr',
                  label: 'Mr',
                },
                {
                  value: 'Mrs',
                  label: 'Mrs',
                },
                {
                  value: 'Ms',
                  label: 'Ms',
                },
                {
                  value: 'Dr',
                  label: 'Dr',
                }
              ]}
            />
          )}
        />

        <small style={{ color: 'red' }}>
          {errors.nameTitle && <p>Please enter Title</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          First Name <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('firstName', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.firstName && <p>Please enter first name</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Last Name <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('lastName', { required: true })}
        />
        <small style={{ color: 'red' }}>
          {errors.lastName && <p>Please enter last name</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Contact No. <span className="login-danger">*</span>
        </label>
        <Controller
          name="mobile"
          control={control}
          rules={{
            required: true,
            pattern: {
              value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
              message: "Please enter valid US mobile number (e.g. 234-567-8900)"
            }
          }}
          render={({ field }) => {
            // Remove +1 prefix from value if it exists to show only the number
            const displayValue = field.value 
              ? String(field.value).replace(/^\+?1/, '').trim()
              : '';
            
            return (
              <Input
                {...field}
                value={displayValue}
                onChange={(e) => {
                  // Remove +1 if user tries to type it
                  let value = e.target.value.replace(/^\+?1/, '').trim();
                  field.onChange(value);
                }}
                addonBefore={
                  <span style={{ 
                    padding: '0 8px',
                    backgroundColor: '#f5f5f5',
                    border: 'none',
                    pointerEvents: 'none',
                    userSelect: 'none'
                  }}>
                    +1
                  </span>
                }
                className="form-control"
                type="tel"
                disabled={isEdit}
                placeholder="234-567-8900"
              />
            );
          }}
        />
        <small style={{ color: 'red' }}>
          {errors.mobile?.type === 'required' && <p>Please enter mobile number</p>}
          {errors.mobile?.type === 'pattern' && <p>{errors.mobile.message}</p>}
        </small>
      </div>
      <div className="form-group">
        <label>
          Email <span className="login-danger">*</span>
        </label>
        <input
          className="form-control"
          type="text"
          disabled={isEdit}
          {...register('email', {
            required: 'Please enter your email!',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Please enter A Valid Email!',
            },
          })}
        />
        <small style={{ color: 'red' }}>{errors.email?.message}</small>
      </div>
      {isEdit ? (
        <div className="form-group">
          <label>
            Status <span className="login-danger">*</span>
          </label>
          <Controller
            id="flexCheckDefault"
            name="status"
            control={control}
            defaultValue={false}
            render={({ field }) => {
              field.checked = field.value;
              return <Switch {...field} className="ms-2" />;
            }}
          />
        </div>
      ) : null}
      <Form.Item>
        <Button
          key="ok"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          Submit
        </Button>
      </Form.Item>
    </form>
  );
});
RadiologistUserForm.propTypes = {
  formValues: PropTypes.object,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  isEdit: PropTypes.bool,
};
export default RadiologistUserForm;
